<template>
  <div class="about-container">
    <div class="header">
      <el-image :src="topImage" :fit="fit" class="mb-10 bs-10 br-10" style="width: 100%; height: 100%;"></el-image>
    </div>
    <div class="height-15"></div>
    <div class="main-container br-10 bs-10">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="left">
            <p class="btlr-10">About Us</p>
            <ul style="background: #FFF;">
              <li><router-link to="/about/company" v-bind:class="{active:active=='company'}" @click.native="changeClass(1,$event)">Company Introduction</router-link></li>
              <li><router-link to="/about/team" v-bind:class="{active:active=='team'}" @click.native="changeClass(2,$event)">Professional Team</router-link></li>
              <li><router-link to="/about/eqp" v-bind:class="{active:active=='eqp'}" @click.native="changeClass(3,$event)">Production Equipment</router-link></li>
              <!--li><router-link to="/about/tech" v-bind:class="{active:active=='tech'}" @click.native="changeClass(4,$event)">Process Flow</router-link></li-->
              <li><router-link to="/about/partners" v-bind:class="{active:active=='partners'}" @click.native="changeClass(5,$event)">Yiree Partner</router-link></li>
              <li><router-link to="/about/video" v-bind:class="{active:active=='video'}" @click.native="changeClass(6,$event)">Video Show</router-link></li>
            </ul>
          </div>
        </el-col>
        <el-col :span="18">
          <router-view/>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  /*import Bus from "../api/Bus";*/
  export default {
    name: 'About',
    data() {
      return {
        active: 'company',
        fit: 'fit',
        topImage: ''
      }
    },
    methods: {
      changeClass(index,e){
          switch(index){
            case 1:
              this.active = 'company';
              this.getTopImage('about');
              break;
            case 2:
              this.active = 'team';
              this.getTopImage('team');
              break;
            case 3:
              this.active = 'eqp';
              this.getTopImage('equip');
              break;
            case 4:
              this.active = 'tech';
              this.getTopImage('process');
              break;
            case 5:
              this.active = 'partners';
              this.getTopImage('partner');
              break;
            case 6:
              this.active = 'video';
              this.getTopImage('video');
              break;
          }
          //Bus.$emit("menu","/about");
          //console.log(e.target.style.color="#A00");
          //可以打印出来e.target里面的值，其实就是页面的dom元素，然后可以按照自己想法更改样式了，还可以根据e找到页面所有节点
          //例如：e.target.parentNode.style.border = "1px solid red";
      },
      getTopImage(name) {
      	this.$axios.get('/api/topimage/'+name).then(res => {
      			//console.log(res.data);
      			if (res.data.code == '0') {
              this.topImage = res.data.data[0].url;
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
    },
    mounted: function () {
      //this.getTopImage();
      //console.log(this.$route.path);
      let path = this.$route.path;
      if(path.indexOf("company") != -1){
        this.active = 'company';
        this.getTopImage('about');
      }else if(path.indexOf("team") != -1){
        this.active = 'team';
        this.getTopImage('team');
      }else if(path.indexOf("eqp") != -1){
        this.active = 'eqp';
        this.getTopImage('equip');
      }else if(path.indexOf("tech") != -1){
        this.active = 'tech';
        this.getTopImage('process');
      }else if(path.indexOf("partners") != -1){
        this.active = 'partners';
        this.getTopImage('partner');
      }else if(path.indexOf("video") != -1){
        this.active = 'video';
        this.getTopImage('video');
      }
    }
  }
</script>

<style scoped>
  .about-container {
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
  }
  .header {
    width: 100%;
    height: 400px;
    margin-bottom: 10px;
    background-color: #DCDFE6;
  }
  .main-container {
    background: #FFF;
    /* padding-right: 10px; */
  }
  .left {
    overflow: hidden;
    white-space: nowrap;
  }

  .left p {
    height: 50px;
    line-height: 50px;
    background-color: #aa0000;
    font-size: 24px;
    color: #FFF;
  }

  .main {

  }

  .left ul {
    list-style: none;
    border-left: 1px solid #DCDFE6;
    border-right: 1px solid #DCDFE6;
  }

  .left ul li {
    border-bottom: 1px solid #DCDFE6;
    height: 40px;
    line-height: 40px;
    font-size: 17px;
    font-weight:540;
    text-align: left;
    padding-left: 30px;
  }

  .left a {
    margin-left: 20px;
  }

  a {
    text-decoration: none;
    color: #000000;
  }

  .left ul li:before {
    content: '>';
  }

  .active {
    color: #AA0000;
  }

  .mb-10 {
    margin-bottom: 10px;
  }
  .bs-10{
    box-shadow: 10px 10px 5px #888888
  }
  .br-10{
    border-radius: 10px;
  }
  .db{
    display: block;
  }
  .btlr-10 {
    border-top-left-radius: 10px;
  }
  .btrr-10 {
    border-top-right-radius: 10px;
  }
  .bblr-10 {
    border-bottom-left-radius: 10px;
  }
  .bbrr-10 {
    border-bottom-right-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/About.vue